import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { RequisitionService } from 'src/app/services/requisition.service';
import { Requisition } from 'src/app/models/requisition';
import { AuthService } from 'src/app/services/auth.service';
import { RequisitionLine } from 'src/app/models/requisition-line';
import { filter } from '../purchase-order/purchase-order.component';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-requisition',
  templateUrl: './requisition.component.html',
  styleUrls: ['./requisition.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class RequisitionComponent implements OnInit {
  filters = {
    byDates: 'dates',
    byOpen: 'open',
    req: 'open', 
    date1: new Date,
    date2: new Date,
  };
  requisitions:Requisition[] = [];
  requisitionsAll:Requisition[] = [];
  loading:boolean = false;

  unities:filter[] = [];
  unity:filter = null;
  users:filter[] = [];
  user:filter = null;

  isSap:boolean = false;

  showFilters:boolean = false;

  constructor( private reqServ:RequisitionService, private auth:AuthService, private toastr:ToastrManager ) { }

  ngOnInit() { }

  search() {
    this.loading = true;
    if (this.filters.req == this.filters.byDates) {
      this.reqServ.getRequisitionsByDates(this.filters.date1, this.filters.date2).then(req => {
        this.requisitions = req;
        this.requisitionsAll = req;
        this.loading = false;
        this.showFilters = true;
        this.createFilters();
      });
    } else {
      this.reqServ.getOpenRequisitions().then(req => {
        this.requisitions = req;this.requisitionsAll = req;
        this.loading = false;
        this.showFilters = true;
        this.createFilters();
      });
    }
  }

  filterData() {
    this.requisitions = this.requisitionsAll.filter(or => (this.user == null || or.user_id == this.user.id) && (this.unity == null || this.hasUnity(or.lines, this.unity.id)));
  }

  hasUnity(lines:RequisitionLine[], unity:number) {
    return lines.find(u => u.unity_id == unity) ? true : false;
  }

  authorize(requisition:Requisition) {
    this.loading = true;
    this.reqServ.authorizeRequisition(requisition).then(resp => {
      requisition.authorized = true;
      requisition.authorized_by = this.auth.getActualUser();
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr("La requisición no puede ser autorizada! tal vez se haya eliminado.");
      this.loading = false;
    });
  }

  createFilters() {
    this.users = [];
    this.unities = [];

    for (let i = 0; i < this.requisitionsAll.length; i++) {
      if (!this.users.find(u => u.name == `${this.requisitionsAll[i].user.name} ${this.requisitionsAll[i].user.last_name}`)) {
        this.users.push({
          id: this.requisitionsAll[i].user_id,
          name: `${this.requisitionsAll[i].user.name} ${this.requisitionsAll[i].user.last_name}`,
        });
      }
      for (let j = 0; j < this.requisitionsAll[i].lines.length; j++) {
        if (this.requisitionsAll[i].lines[j].unity_id && !this.unities.find(u => u.id == this.requisitionsAll[i].lines[j].unity_id)) {
          this.unities.push({
            id: this.requisitionsAll[i].lines[j].unity_id,
            name: this.requisitionsAll[i].lines[j].unity_id + "",
          });
        }
      }
    }
  }

}
